export default "/_next/static/images/dog4-cc6ba29e711084321cde299c63c5f7aa.png";